{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Overfør til en operatør",
    "MESSAGE": "Sett meg over til en operatør"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Last ned",
      "UPLOADING": "Laster opp..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Send"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Send meldingen på nytt",
      "ERROR_MESSAGE": "Kunne ikke sende, prøv på nytt"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Vurder kvaliteten på dette svaret"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Vennligst vent på at en agent blir med"
  },
  "ROBOT_CHECK": {
    "TITLE": "Rask sikkerhetssjekk",
    "DESCRIPTION": "Vennligst fullfør sjekken nedenfor.",
    "VERIFYING": "Bekrefter…",
    "ERROR": "Det fungerte ikke. Vennligst prøv igjen.",
    "RETRY": "Prøv igjen"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Vi er pålogget",
    "OFFLINE": "Vi er for øyeblikket borte",
    "ONLINE_WITH_BOT": "Teamet og vår AI-assistent er online",
    "OFFLINE_WITH_BOT": "Vår AI-assistent er her for å hjelpe deg",
    "BOT_ONLY_REPLY": "Svarer umiddelbart"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Svarer vanligvis innen et par timer",
    "IN_A_FEW_HOURS": "Svarer vanligvis innen et par timer",
    "IN_A_DAY": "Svarer vanligvis innen en dag",
    "BACK_IN": "Vi vil være tilbake online"
  },
  "DAY_NAMES": {
    "SUNDAY": "Søndag",
    "MONDAY": "Mandag",
    "TUESDAY": "Tirsdag",
    "WEDNESDAY": "Onsdag",
    "THURSDAY": "Torsdag",
    "FRIDAY": "Fredag",
    "SATURDAY": "Lørdag"
  },
  "START_CONVERSATION": "Start samtale",
  "END_CONVERSATION": "Avslutt samtale",
  "CONTINUE_CONVERSATION": "Fortsett samtalen",
  "YOU": "Du",
  "START_NEW_CONVERSATION": "Start en ny samtale",
  "RESOLVE_LATER": "Vi løser dette emnet via e-post/telefon. Jeg vil spørre om noe annet nå.",
  "VIEW_UNREAD_MESSAGES": "Du har uleste meldinger",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Se nye meldinger",
    "CLOSE_MESSAGES_BUTTON": "Lukk",
    "COMPANY_FROM": "fra",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Chat med oss"
  },
  "POWERED_BY": "Drevet av {brandName}",
  "EMAIL_PLACEHOLDER": "Skriv inn din e-post",
  "CHAT_PLACEHOLDER": "Skriv inn meldingen",
  "TODAY": "I dag",
  "YESTERDAY": "I går",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Fullt navn",
        "PLACEHOLDER": "Skriv inn fullt navn",
        "REQUIRED_ERROR": "Fullt navn er påkrevd"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "E-postadresse",
        "PLACEHOLDER": "Vennligst skriv inn din e-postadresse",
        "REQUIRED_ERROR": "E-postadresse er påkrevd",
        "VALID_ERROR": "Vennligst skriv inn en gyldig e-postadresse"
      },
      "PHONE_NUMBER": {
        "LABEL": "Telefonnummer",
        "PLACEHOLDER": "Tast inn ditt telefonnummer",
        "REQUIRED_ERROR": "Telefonnummer er påkrevd",
        "DIAL_CODE_VALID_ERROR": "Vennligst velg landskode",
        "VALID_ERROR": "Tast inn ditt telefonnummer",
        "DROPDOWN_EMPTY": "Ingen resultater funnet",
        "DROPDOWN_SEARCH": "Søk etter land"
      },
      "MESSAGE": {
        "LABEL": "Melding",
        "PLACEHOLDER": "Skriv inn meldingen din",
        "ERROR": "Meldingen er for kort"
      }
    },
    "CAMPAIGN_HEADER": "Angi navn og e-post før du starter samtalen",
    "IS_REQUIRED": "er påkrevd",
    "REQUIRED": "Påkrevd",
    "REGEX_ERROR": "Vennligst oppgi gyldige opplysninger"
  },
  "FILE_SIZE_LIMIT": "Filens størrelse overskrider grensen på {MAXIMUM_FILE_UPLOAD_SIZE}",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Ugyldig felt"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Søk emojier",
    "NOT_FOUND": "Ingen emojier samsvarer søket ditt",
    "ARIA_LABEL": "Emoji velger"
  },
  "CSAT": {
    "TITLE": "Vurder samtalen din",
    "SUBMITTED_TITLE": "Takk for at du ga din vurdering",
    "PLACEHOLDER": "Fortell oss mer..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Be om utskrift av samtalen",
    "SEND_EMAIL_SUCCESS": "Kopi av samtalen ble sendt",
    "SEND_EMAIL_ERROR": "Det oppstod en feil. Prøv igjen"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Populære artikler",
    "VIEW_ALL_ARTICLES": "Vis alle artikler",
    "IFRAME_LOAD_ERROR": "Det oppstod en feil under lasting av artikkelen, oppdater siden og prøv igjen."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Åpne",
      "BUY": "Kjøp"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Bildemelding"
    },
    "audio": {
      "CONTENT": "Lydmelding"
    },
    "video": {
      "CONTENT": "Video beskjed"
    },
    "file": {
      "CONTENT": "Vedlegg"
    },
    "location": {
      "CONTENT": "Plassering"
    },
    "fallback": {
      "CONTENT": "har delt en URL"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Svar til:"
  }
}
